angular.module('salesPath2')
    .controller('searchCtrl', ['$scope', 'searchHelper', 'dataContainerHelper', 'actionHelper', function($scope, searchHelper, dataContainerHelper, actionHelper) {
        
        $scope.CLIENT_SEARCH = searchHelper.CLIENT_SEARCH;
        $scope.CLIENT_AND_VEHICLE_SEARCH = searchHelper.CLIENT_AND_VEHICLE_SEARCH;
        var availableTabs = [$scope.CLIENT_SEARCH, $scope.CLIENT_AND_VEHICLE_SEARCH];
        
        $scope.activeTabName = !searchHelper.activeTabName || !availableTabs.includes(searchHelper.activeTabName)
            ? $scope.CLIENT_AND_VEHICLE_SEARCH
            : searchHelper.activeTabName;

        $scope.tplData = searchHelper.tplData;
        
        $scope.changeTab = function(tabName) {
            $scope.activeTabName = tabName;
            searchHelper.activeTabName = tabName;
        };

        /**
        * nasluchuje na akcje actionHelpera
        * @type {Object}
        */
        $scope.searchCtrlListener = {
         /**
          * reakcja na akcje w aplikacji
          * @param  {String} actionName nazwa wykonanej akcji
          */
         _afterAction: function(actionName) {
           if (actionName === 'apkDetailsSet') {  
                var apkDetails = dataContainerHelper.getApkDetails();
                $scope.changeTab(apkDetails.attributes && apkDetails.attributes.vehicleRegistrationNumber ? $scope.CLIENT_AND_VEHICLE_SEARCH : $scope.CLIENT_SEARCH);
                actionHelper.runAction('apkTabChanged');
           }
         }
        };

        actionHelper.registerHelper('searchCtrl', $scope.searchCtrlListener, [
          'apkDetailsSet'
        ]);
        
    }]);